// Copy lives in src/locales/<lang>/<namespace>.json — one namespace per feature, English first.
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const files = import.meta.glob('../locales/*/*.json', { eager: true, import: 'default' }) as Record<string, Record<string, unknown>>;
const resources: Record<string, Record<string, Record<string, unknown>>> = {};
for (const [path, json] of Object.entries(files)) {
  const m = path.match(/locales\/([^/]+)\/([^/]+)\.json$/);
  if (!m) continue;
  (resources[m[1]!] ??= {})[m[2]!] = json;
}

void i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  ns: Object.keys(resources.en ?? {}),
  defaultNS: 'common',
  interpolation: { escapeValue: false },
});

export default i18n;
